"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var elmer_common_1 = require("elmer-common");
var defineReduxProvider_1 = require("./defineReduxProvider");
var ReduxGlobalStateKeys_1 = require("./ReduxGlobalStateKeys");
exports.connect = function (reduxController, Component, mapStateToPropsFn, mapDispatchToPropsFn, getGlobalState, defineGlobalState) {
    var stateID = ReduxGlobalStateKeys_1.REDUX_GLOBAL_LISTEN_KEY;
    var stateData = getGlobalState(stateID);
    var checkSelector = Component.prototype.selector;
    if (checkSelector !== undefined && checkSelector !== null) {
        if (!stateData) {
            var gState = defineReduxProvider_1.defineReduxProvider(getGlobalState, defineGlobalState);
            stateData = gState.listener;
            gState = null;
        }
        if (!stateData[checkSelector]) {
            elmer_common_1.defineReadonlyProperty(reduxController.stateWatchs, checkSelector, {
                mapDispatchToProps: mapDispatchToPropsFn,
                mapStateToProps: mapStateToPropsFn
            });
        }
    }
    checkSelector = null;
    stateID = null;
};
